/* import __COLOCATED_TEMPLATE__ from './modal-footer-close.hbs'; */
import Component from "@ember/component";

export default Component.extend({});
